// src/routes/Guides.jsx
import ContentPage from "@/components/content/ContentPage";

const Guides = () => <ContentPage docKey="guides" />;

export default Guides;
